/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import classNames from 'classnames';

import Signals from '../../../signals/Signals';
import OfferDynamicValues, { convertTranslationsToTags } from '../../../data/OfferDynamicValues';

import FormField from '../../../components/ui/FormField/FormField';
import FormGroup from '../../../components/ui/FormGroup/FormGroup';
// eslint-disable-next-line import/no-named-as-default
import TagTextArea, { TYPE_TEXTINPUT } from '../../../components/ui/TagTextArea/TagTextArea';

import { ApplicationContext } from '../../../ApplicationContext';
import { FormErrorContext } from '../../../FormErrorContext';

import UpdateOfferSettingsCommand from '../../../commands/offers/UpdateOfferSettingsCommand';

/**
 *
 */
class OffersSettingsDutch extends React.Component {
	/**
	 *
	 * @param props
	 */
	constructor(props) {
		super(props);

		this.onSubmit = this.onSubmit.bind(this);
		this.onSubmitError = this.onSubmitError.bind(this);
		this.onSubmitSuccess = this.onSubmitSuccess.bind(this);
		this.onInputChange = this.onInputChange.bind(this);

		//
		this.dynamicTags = [];
		for (const key in OfferDynamicValues) {
			if (OfferDynamicValues.hasOwnProperty(key)) {
				this.dynamicTags.push(OfferDynamicValues[key]);
			}
		}
	}

	/**
	 *
	 */
	componentWillMount() {
		// Set initial state
		const company = this.context.applicationStore.getSelectedCompany();
		if (company) {
			this.state = company.offersSettings.toObject();
			this.state.errors = [];

			// Apply intl translations when object, and convert translation variables to OfferDynamicValues
			for (const key in this.state) {
				if (this.state.hasOwnProperty(key)) {
					switch (key) {
						// Convert translations / store strings to TagTextarea formatted strings
						case 'defaultOfferEmailMessage':
						case 'defaultOfferEmailSubject':
						case 'reminderMessage':
						case 'reminderSubject':
						case 'defaultNotes':
							if (typeof this.state[key] === 'object') {
								this.state[key] = convertTranslationsToTags(
									this.props.intl.formatMessage(this.state[key])
								);
							} else {
								this.state[key] = convertTranslationsToTags(this.state[key]);
							}
							break;
						default:
							break;
					}
				}
			}
		}
	}

	/**
	 *
	 * @return {*}
	 */
	render() {
		const company = this.context.applicationStore.getSelectedCompany();

		if (!this.context.applicationStore.isLoggedIn || !company) {
			return null;
		}

		//
		const { intl } = this.props;
		const { submitting, errors } = this.state;
		const formClasses = classNames({ 'form--submitting': submitting });

		return (
			<FormErrorContext.Provider value={{ errors }}>
				<form
					className={`offers-settings__panel panel grid col--12 box-shadow border border--dark ${formClasses}`}
					onSubmit={this.onSubmit}
					onChange={this.onInputChange}>
					<div className="offers-settings__header padding border--bottom border--dark">
						<h2 className="pad-left">
							<FormattedMessage id="offers.settings.title.dutch" />
						</h2>
					</div>

					<div className="offers-settings__content">
						{this._getSendSettings()}
						{this._getRemindSettings()}
						{this._getNotes()}

						<div className="options-footer offers-settings__footer border--top border--dark grid grid--spread">
							<div className="grid user-info__footer-buttons" />
							<input type="submit" value={intl.formatMessage({ id: 'label.save' })} />
						</div>
					</div>
				</form>
			</FormErrorContext.Provider>
		);
	}

	/**
	 *
	 * @param e
	 */
	onInputChange(e) {
		const newState = {};
		newState[e.target.name] = e.target.value;
		this.setState(newState);
	}

	/**
	 *
	 * @param e
	 */
	onSubmit(e) {
		if (e) {
			e.preventDefault();
		}

		if (this.state.submitting) {
			return;
		}

		this.setState({ errors: null, submitting: true });

		const company = this.context.applicationStore.getSelectedCompany();
		const command = new UpdateOfferSettingsCommand(this.props.intl, company, this.state);
		command.execute(this.onSubmitSuccess, this.onSubmitError);
	}

	/**
	 *
	 * @param response
	 */
	onSubmitSuccess(_response) {
		// Display success message
		Signals.ShowMessageDialog.dispatch(
			<FormattedMessage id="offer.settings.update.success.message" />
		);

		// Reset state
		this.setState({
			submitting: false,
			errors: null
		});
	}

	/**
	 *
	 * @param error
	 */
	onSubmitError(error) {
		if (error.response && error.response.body) {
			this.setState({ errors: error.response.body });
		} else {
			Signals.Error.dispatch(error);
		}

		this.setState({ submitting: false });
	}

	/**
	 *
	 * @private
	 */
	_getSendSettings() {
		return (
			<FormGroup className="padding padding-none--bottom" errors={this.state.errors}>
				<FormField>
					<h2 className="font--title">
						<FormattedMessage id="offer.settings.subtitle.send" />
					</h2>
				</FormField>
				<FormField className="col--12 form-field__padding-bottom">
					<label>
						<FormattedMessage id="offer.settings.offer.subject.title" />
					</label>
					<TagTextArea
						name="defaultOfferEmailSubject"
						type={TYPE_TEXTINPUT}
						value={this.state.defaultOfferEmailSubject}
						tags={this.dynamicTags}
					/>
				</FormField>

				<FormField className="col--12 margin-none--bottom">
					<label>
						<FormattedMessage id="offer.settings.offer.message.title" />
					</label>
					<TagTextArea
						name="defaultOfferEmailMessage"
						value={this.state.defaultOfferEmailMessage}
						tags={this.dynamicTags}
					/>
				</FormField>
			</FormGroup>
		);
	}

	/**
	 *
	 * @private
	 */
	_getRemindSettings() {
		return (
			<FormGroup className="padding padding-none--bottom" errors={this.state.errors}>
				<FormField>
					<h2 className="font--title ">
						<FormattedMessage id="offer.settings.subtitle.remind" />
					</h2>
				</FormField>
				<FormField className="col--12 form-field__padding-bottom">
					<label>
						<FormattedMessage id="offer.settings.offer.remindersubject.title" />
					</label>
					<TagTextArea
						name="reminderSubject"
						type={TYPE_TEXTINPUT}
						value={this.state.reminderSubject}
						tags={this.dynamicTags}
					/>
				</FormField>

				<FormField className="col--12 form-field__padding-bottom">
					<label>
						<FormattedMessage id="offer.settings.remind.message.title" />
					</label>
					<TagTextArea
						name="reminderMessage"
						value={this.state.reminderMessage}
						tags={this.dynamicTags}
					/>
				</FormField>
			</FormGroup>
		);
	}

	/**
	 *
	 * @return {*}
	 * @private
	 */
	_getNotes() {
		return (
			<FormGroup className="padding" errors={this.state.errors}>
				<FormField>
					<h2 className="font--title ">
						<FormattedMessage id="offer.settings.notes" />
					</h2>
				</FormField>

				<FormField className="col--12 form-field__padding-bottom">
					<label>
						<FormattedMessage id="offer.settings.defaultnotes.message.title" />
					</label>
					<textarea name="defaultNotes" value={this.state.defaultNotes} />
				</FormField>
			</FormGroup>
		);
	}
}

OffersSettingsDutch.contextType = ApplicationContext;

OffersSettingsDutch.propTypes = {
	intl: PropTypes.object
};

export default injectIntl(OffersSettingsDutch);
